class LogoutService {
    constructor($rootScope, $state, $timeout, sseService, principalService, storageService, sharedPersistenceService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.sseService = sseService;
        this.principalService = principalService;
        this.storageService = storageService;
        this.sharedPersistence = sharedPersistenceService;
    }

    logout() {
        this.sseService.closeSSEStream(true);
        this.storageService.onLogout();
        this.principalService.clearIdentity();
        this.$rootScope.$emit("logout");
        this.sharedPersistence.clusterRenderCounter = 0;
        this.$timeout(() => {
            this.$state.go("login");
        }, 0);
    }
}

LogoutService.$inject = ['$rootScope', '$state', '$timeout', 'sseService', 'principalService', 'storageService', 'sharedPersistenceService'];

module.exports = LogoutService;



// WEBPACK FOOTER //
// ./src/azurebackup/services/logout.service.js